@if (body.beglaubigte) {
	<div data-test-id="beglaubigte">{{ body.beglaubigte }} beglaubigte</div>
}
@if (body.einfache) {
	<div data-test-id="einfache">{{ body.einfache }} einfache</div>
}
